import React from 'react';
import classNames from 'classnames';
import './index.scss';

export interface BlackLogoProps {}

const BlackLogo = ({}: BlackLogoProps): React.ReactElement => {
  /* ======================================================
   * variables
   * ====================================================== */
  const cx = classNames.bind('./index.scss');

  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <div>
      <img src="/assets/images/hsg_logo_b.png" alt="logo" className={cx('blackLogo')} />
    </div>
  );
};

export default BlackLogo;
